import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { PATH_NAV_ITEMS } from './constants';
import PathItem from './PathItem';

type PathNavigationBarProps = {
  fixed: boolean;
};

const PathNavigationBar: React.FC<PathNavigationBarProps> = ({ fixed }) => {
  const hash = window.location.hash
    ? window.location.hash.substring(1, window.location.hash.length)
    : '';

  const [activeDiv, setActiveDiv] = useState<string>(hash || 'overview');

  const checkIsActive = (num: string): boolean => {
    if (num === activeDiv) return true;
    else return false;
  };

  const onSetActiveDiv = (value: string): void => {
    setActiveDiv(value);
  };

  return (
    <Box
      position={{
        xs: 'static',
        sm: fixed ? 'fixed' : 'static',
      }}
      top={{
        xs: '',
        sm: fixed ? '6%' : '',
      }}
      maxWidth={{
        xs: 'auto',
        sm: '161px',
      }}
      width={{
        xs: '100%',
        sm: '30%',
      }}
      px={{
        xs: 3,
      }}
      mb={{
        xs: 4,
      }}
      display='flex'
      flexDirection='column'
    >
      <Typography
        whiteSpace='nowrap'
        fontSize='14px'
        fontWeight={600}
        lineHeight='20px'
      >
        On this page
      </Typography>
      <Typography fontSize='24px' fontWeight={500} lineHeight='32px'>
        Path
      </Typography>
      <Box
        id='sidebar'
        display='flex'
        flexWrap={{
          xs: 'wrap',
        }}
        flexDirection={{
          xs: 'row',
          sm: 'column',
        }}
      >
        {PATH_NAV_ITEMS.map((pathItem) => (
          <PathItem
            key={pathItem.id}
            isActive={checkIsActive(pathItem.id)}
            pathItem={pathItem}
            setActive={onSetActiveDiv}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PathNavigationBar;
